<template>
  <div>
    <v-container>
      <!-- Button above the list -->
      <v-row class="mb-3">
        <v-col class="d-flex justify-end">
          <v-btn
            color="primary"
            x-small
            @click="openDialog"
          >
            Fee Import Utility
          </v-btn>
        </v-col>
      </v-row>

      <CRUDList
        :canAdd="canAddToSharedList"
        :canEdit="true"
        :canSave="canEditSharedList"
        :headers="headers"
        :baseCrudKey="baseCrudKey"
        :createNewItem="newItemDialog"
        toolbarTitle="Fee Master"
        @loadCRUDList="handleLoadCRUDList"
        @upsertItem="upsrtTransaction"
        :defaultSortBy="sortBy"
        :loadingData="gridLoading.flag"
        :loadingText="gridLoading.text"
      >
        <template v-slot:[`editedItem`]="{}">
          <taxFeeEditItem :baseCrudKey="baseCrudKey" />
        </template>
      </CRUDList>
      <!-- Dialog -->
      <v-dialog v-model="dialog" max-width="600px">
        <v-card>
          <v-card-title>
            <span class="text-h5">Fee Utility</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <!-- Row 1 -->
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="dialogForm.mailFeeNumber"
                    label="Fee Number"
                    placeholder=""
                    type="number"
                    class="input-text-size pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-text-field
                    v-model="dialogForm.mailFeeDesc"
                    label="Mail Fee Description"
                    placeholder=""
                    class="input-text-size pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    color="primary"
                    x-small
                    @click="handleSaveButtonClick(
                      dialogForm.mailFeeNumber,
                      dialogForm.mailFeeDesc,
                      'mailFee'
                    )"
                  >
                    Save
                  </v-btn>
                </v-col>
              </v-row>
              <!-- Row 2 -->
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="dialogForm.lienFeeNumber"
                    label="Fee Number"
                    placeholder=""
                    type="number"
                    class="input-text-size pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-text-field
                    v-model="dialogForm.lienFeeDesc"
                    label="Lien Fee Description"
                    placeholder=""
                    class="input-text-size pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    color="primary"
                    x-small
                    @click="handleSaveButtonClick(
                      dialogForm.lienFeeNumber,
                      dialogForm.lienFeeDesc,
                      'lienFee'
                    )"
                  >
                    Save
                  </v-btn>
                </v-col>
              </v-row>
              <!-- Row 3 -->
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="dialogForm.advFeeNumber"
                    label="Adv Fee Number"
                    placeholder=""
                    type="number"
                    class="input-text-size pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="dialogForm.advFeeDesc"
                    label="Adv fee Description"
                    placeholder=""
                    class="input-text-size pa-0"
                  ></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    color="primary"
                    x-small
                    @click="handleSaveButtonClick(
                      dialogForm.advFeeNumber,
                      dialogForm.advFeeDesc,
                      'advFee'
                    )"
                  >
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="closeDialog"
            >
              Cancel
            </v-btn>
            <!-- <v-btn
              color="blue darken-1"
              text
              @click="handleDialogAction"
            >
              Save
            </v-btn> -->
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import taxFeeEditItem from './taxFeeEditItem.vue';
import { defaultGridLoading, manageGridLoading } from '../../../util/shared/vue-global';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';

const getHeaders = () => {
  const headers = [
    { text: 'Fee Number', value: 'feeNumber' },
    { text: 'Fee Description', value: 'feeDescription' },
    { text: 'To Unit', value: 'toUnit' },
  ];
  return headers;
};

export default {
  name: 'taxFeeTypesList',
  mixins: [SharedListAccessControlMixin],
  components: {
    CRUDList,
    taxFeeEditItem,
  },
  data: () => ({
    baseCrudKey: 'sharedTaxFeeMaster',
    gridLoading: defaultGridLoading(),
    dialog: false,
    dialogForm: {
      mailFeeNumber: '',
      mailFeeDesc: '',
      lienFeeNumber: '',
      lienFeeDesc: '',
      advFeeNumber: '',
      advFeeDesc: '',
    },

    headers: [],
    sortBy: [
      {
        column: 'feeNumber',
        direction: 'asc',
      },
    ],
  }),
  created() {
    this.headers = getHeaders();
    this.initCriteria();
  },
  methods: {
    ...mapActions('shared/taxFeeMaster', ['loadTaxFeeMasterTypes', 'upsertFeeMasterTypes',
      'upsertImportFeeMaster', 'importFeeMasterDetails']),
    ...mapMutations('base/crud', ['setCriteria']),
    async upsrtTransaction(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      await this.upsertFeeMasterTypes({ item: updatedItem, baseCrudKey });
    },
    handleLoadCRUDList() {
      const { baseCrudKey } = this;
      const criteria = { ...this.criteriaState };
      manageGridLoading(this, true, 'Searching...');
      this.loadTaxFeeMasterTypes({
        criteria,
        baseCrudKey,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        feeNumber: '',
        feeDescription: '',
        toUnit: '',
      };
      return newItem;
    },
    initCriteria() {
      this.criteriaState = {};
    },
    async openDialog() {
      const res = await this.importFeeMasterDetails({ criteria: { } });
      this.dialog = true;
      // Reset form when opening dialog
      if ((res || []).length > 0) {
        res.forEach((item) => {
          if (item.tag === 'mailFee') {
            this.dialogForm.mailFeeNumber = item.feeNumber || '';
            this.dialogForm.mailFeeDesc = item.feeDescription || '';
          } else if (item.tag === 'advFee') {
            this.dialogForm.advFeeNumber = item.feeNumber || '';
            this.dialogForm.advFeeDesc = item.feeDescription || '';
          } else if (item.tag === 'lienFee') {
            this.dialogForm.lienFeeNumber = item.feeNumber || '';
            this.dialogForm.lienFeeDesc = item.feeDescription || '';
          }
        });
      } else {
        this.dialogForm = {
          mailFeeNumber: '',
          mailFeeDesc: '',
          lienFeeNumber: '',
          lienFeeDesc: '',
          advFeeNumber: '',
          advFeeDesc: '',
        };
      }
    },
    closeDialog() {
      this.dialog = false;
    },
    async handleSaveButtonClick(feeNumber, feeDescription, tag) {
      if (!feeNumber || !feeDescription) {
        console.warn('Both fee number and description are required');
        return;
      }
      const item = {
        feeNumber: Number(feeNumber),
        feeDescription,
        tag,
      };
      await this.upsertImportFeeMaster({ item });
    },
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'index', 'item']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
  },
};
</script>
